export default __webpack_public_path__ + "media/zurb/img/lab/playground/orbit-arrow-right-d142d7e13719f0357bcb0bcc671ba450.svg";